import React from 'react'

const MapSku = ({ isShow, item, handleChangeShow, limit }) => {

    const strProductTypes = item.product_types.join(", ")
    return (
        <>
            <div className={!isShow ? "showAll" : ""}>
                {
                    (!item.apply_for_all && !!item.product_types) ?
                        (isShow ? strProductTypes : strProductTypes.substr(0, limit))
                        : 'All'
                }
            </div>
            {
                (!isShow && strProductTypes.length > 450) ? <small className="float-right text-primary cursor-pointer" onClick={handleChangeShow}>More...</small> :
                    (isShow && strProductTypes.length > 450) ? <small className="float-right text-primary cursor-pointer" onClick={handleChangeShow}>Less...</small> : ""
            }
        </>
    )
}

export default MapSku